import { messageTypes } from '../types';
import messages from 'config/messages.json';
import { messageTime } from 'config'

export const showMessage = (message) => async (dispatch) => {
    dispatch({ type: messageTypes.MESSAGE_REQUEST });

    try {
        const { textId, target, desc } = message;
        const selected = messages.filter((m) => m.id === textId);

        dispatch({
            type: messageTypes.MESSAGE_SHOW,
            ...message,
            ...selected[0],
            target: target || 'top',
            desc: desc ? desc : selected[0].desc,
        });
    } catch (error) {
        dispatch({
            type: messageTypes.MESSAGE_VIEW_ERROR,
            error,
        });
        return false;
    }
};

export const clearMessage = (messageId) => async (dispatch) => {
    setTimeout(() => {
        dispatch({
            type: messageTypes.MESSAGE_CLEAR,
            messageId,
        });
    }, messageTime);

    return true;
};
